import React, { useState, useEffect } from "react";
import { API_Link, validateHeader, API_SRC } from "../commons/Constants";
import axios from "axios";
import { useSnackbar } from "notistack";
import userImgAvator from "./../assets/img/user.png";
function Profile() {
  const { enqueueSnackbar } = useSnackbar();
  const [isEditingName, setIsEditingName] = useState(false);
  const [isEditingPassword, setIsEditingPassword] = useState(false);
  const [isUpdatingData, setIsUpdating] = useState(false);
  const [isUploadingImg, setIsUploadingImg] = useState(false);
  const [token, settoken] = useState(null);
  const MD5hash = validateHeader()
  // State for user current data
  const [userCurrentData, setUserCurrentData] = useState({
    name: "",
    email: "",
  });

  // State for user Updated data
  const [userNewData, setUserNewData] = useState({
    name: "",
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  // Error messages
  const [errors, setErrors] = useState({
    currenPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  // State for handling the image upload
  const [profileImage, setProfileImage] = useState(null);
  const [hovered, setHovered] = useState(false);

  // Fetch user data from local storage when component mounts
  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user")) || {};
    setUserCurrentData({
      name: storedUser.user.name || "",
      email: storedUser.user.email || "",
    });
    setProfileImage(storedUser.user.profile_img_url )
    settoken(storedUser?.token);
  }, []);

  // Handle Change Name button click
  const handleChangeNameClick = () => {
    setIsEditingName(true);
  };

  // Handle Change Password button click
  const handleChangePasswordClick = () => {
    setIsEditingPassword(true);
  };

  // Handle Cancel button click
  const handleCancelClick = () => {
    setIsEditingName(false);
    setIsEditingPassword(false);
    setErrors({ newPassword: "", confirmPassword: "" });
    // Reset userNewData fields
    setUserNewData({
      ...userNewData,
      name: "",
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
    });
  };

  // Validate new password and confirm password
  const validatePasswordFields = () => {
    let isValid = true;
    const newErrors = { newPassword: "", confirmPassword: "" };

    if (userNewData.newPassword !== userNewData.confirmPassword) {
      newErrors.confirmPassword =
        "New Passwords and Confirm Password do not match.";
      isValid = false;
    }

    if (userNewData.newPassword.length < 6) {
      newErrors.newPassword = "Password must be at least 6 characters.";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  // Handle form submission
  const handleUpdate = async (event) => {
    event.preventDefault();
    if (!validatePasswordFields() && isEditingPassword) return;

    // Update logic here
    const updatedUser = {
      name: userNewData.name || userCurrentData.name,
      currentPassword: userNewData.currentPassword,
      newPassword: userNewData.confirmPassword,
    };

    // console.log("Updated User", updatedUser);
    setIsUpdating(true);
    try {
      const config = {
        method: "post",
        url: `${API_Link}updateProfile`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          "misr-auth": MD5hash,
        },
        data: updatedUser,
      };

      const response = await axios(config);
      console.log("response", response);
      enqueueSnackbar(response?.data?.message, {
        variant: "success",
        autoHideDuration: 2000,
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });

      setUserCurrentData((prev) => ({
        ...prev,
        name: response?.data?.user?.name,
      }));

      // Update local storage
      const retrievedUser = localStorage.getItem("user");
      const parsedUser = JSON.parse(retrievedUser);
      parsedUser.user.name = response?.data?.user?.name;
      const modifieduser = JSON.stringify(parsedUser);
      localStorage.setItem("user", modifieduser);

      setIsEditingName(false);
      setIsEditingPassword(false);

      window.location.reload(false);
    } catch (error) {
      console.log("error", error);
      enqueueSnackbar(error.response?.data?.error_message || error.message, {
        variant: "error",
        autoHideDuration: 2000,
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });

      setErrors((prev) => ({
        ...prev,
        currenPassword: error?.response?.data?.error_message,
      }));
    } finally {
      setIsUpdating(false);
     
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserNewData({
      ...userNewData,
      [name]: value,
    });
  };

  const handleImageChange = async (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setIsUploadingImg(true)
      try {
        const formData = new FormData();
        formData.append("profileImage", file);
  
        const config = {
          method: "post",
          url: `${API_Link}uploadProfileImg`, 
          headers: {
            Authorization: `Bearer ${token}`, 
            "misr-auth": MD5hash, 
          },
          data: formData, 
        };
  
        const response = await axios(config);
        // console.log("response", response);
        setProfileImage(response?.data?.user?.profileImage);

        enqueueSnackbar(response?.data?.message, {
          variant: "success",
          autoHideDuration: 2000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
        // Update local storage
        const retrievedUser = localStorage.getItem("user");
        const parsedUser = JSON.parse(retrievedUser);
        parsedUser.user.profile_img_url = response?.data?.user?.profileImage;
        const modifiedUser = JSON.stringify(parsedUser);
        localStorage.setItem("user", modifiedUser);

        window.location.reload(false); 
      } catch (error) {
        console.log("error", error);
        enqueueSnackbar(error.response?.data?.error_message || error.message, {
          variant: "error",
          autoHideDuration: 2000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
      } finally {
        setIsUploadingImg(false)
      }
    }
  };
  

  return (
    <div className="p-4 page--content">
      <div className="page--section p-l-50">
        <h2 className="page--heading">Profile</h2>
        <h5 className="mb-3 text-muted   font-size-14">Manage your profile</h5>
        <hr />
        <section className="mb-4">
          <h4 className="heading3 font-size-20 ">Your photo</h4>
          <h5 className="text-muted  font-size-14">JPEG, PNG, Max. file size: 5 MB</h5>
          <div
            className="mt-3 position-relative"
            style={{ width: "96px", height: "96px" , borderRadius: "100%"}}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
          >
            <span
              className="rounded-circle bg-secondary text-white d-flex justify-content-center align-items-center"
              style={{ width: "96px", height: "96px" }}
            >
              <img
              // src={profileImage || userImgAvator}
              src={
                profileImage
                  ? `${API_SRC}/${profileImage}`
                  : userImgAvator
              }
              alt="Profile"
              className="rounded-circle"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
            </span>
            {hovered && (
            <div
              className="position-absolute d-flex justify-content-center align-items-center"
              style={{
                bottom: 0,
                width: "100%",
                height: "50%",
                background: "rgba(0, 0, 0, 0.5)",
                color: "white",
                transition: "0.3s",
                borderBottomLeftRadius: "86px",
                borderBottomRightRadius: "86px",
              }}
            >
              <label
                htmlFor="image-upload"
                style={{
                  fontSize: "13px",
                  cursor: "pointer",
                }}
              >
                {isUploadingImg ? "Uploading..." : "Upload"}
              </label>
              <input
                type="file"
                id="image-upload"
                style={{ display: "none" }}
                accept="image/*"
                onChange={handleImageChange}
                disabled={isUploadingImg}
                
              />
            </div>
             )}  
          </div>
        </section>
        <hr />
        <section>
          <h4 className="heading3 font-size-20 ">Contact Information</h4>
          <h5 className="text-muted  font-size-14">Change your contact information</h5>
          <form onSubmit={handleUpdate}>
            <div className="form-group mt-3">
              <label>Email</label>
              <input
                type="email"
                className="form-control wd-213 mt-1"
                disabled
                value={userCurrentData.email}
                style={{
                 userSelect: "none",
                 cursor: "not-allowed"
                }}
              />
            </div>
            <div className="d-flex align-items-end mt-1">
              {!isEditingName ? (
                <>
                  <div className="form-group me-5">
                    <label>Name</label>
                    <input
                      type="text"
                      className="form-control mt-1"
                      value={userCurrentData.name}
                      disabled
                      style={{
                        userSelect: "none",
                        cursor: "not-allowed"
                       }}
                    />
                  </div>
                  <button
                    type="button"
                    className="btn btn-primary  btn-sm"
                    onClick={handleChangeNameClick}
                  >
                    Change Name
                  </button>
                </>
              ) : (
                <>
                  <div className="form-group mt-3">
                    <label>New Name</label>
                    <input
                      type="text"
                      name="name"
                      className="form-control wd-213 mt-1"
                      placeholder="Enter new name"
                      value={userNewData.name}
                      onChange={handleInputChange}
                    />
                  </div>
                </>
              )}
            </div>

            {!isEditingPassword ? (
              <>
                <div className="d-flex align-items-end">
                  <div className="form-group mt-3 me-5">
                    <label>Password</label>
                    <input
                      type="password"
                      className="form-control wd-213 mt-1"
                      disabled
                      defaultValue="ihsan123"
                      style={{
                        userSelect: "none",
                        cursor: "not-allowed"
                       }}
                    />
                  </div>
                  <button
                    className="btn btn-primary mt-2  btn-sm"
                    onClick={handleChangePasswordClick}
                  >
                    Change Password
                  </button>
                </div>
              </>
            ) : (
              <>
                <div className="form-group mt-3">
                  <label>Current Password</label>
                  <input
                    type="password"
                    name="currentPassword"
                    className="form-control wd-213 mt-1"
                    placeholder="Enter current password"
                    value={userNewData.currentPassword}
                    autoComplete="current-password"
                    onChange={handleInputChange}
                  />
                  {errors.currenPassword && (
                    <div className="text-danger mt-1">
                      {errors.currenPassword}
                    </div>
                  )}
                </div>
                <div className="form-group mt-3">
                  <label>New Password</label>
                  <input
                    type="password"
                    name="newPassword"
                    className="form-control wd-213 mt-1"
                    placeholder="Enter new password"
                    value={userNewData.newPassword}
                    onChange={handleInputChange}
                    autoComplete="new-password"
                  />
                  {errors.newPassword && (
                    <div className="text-danger mt-1">{errors.newPassword}</div>
                  )}
                </div>
                <div className="form-group mt-3">
                  <label>Confirm Password</label>
                  <input
                    type="password"
                    name="confirmPassword"
                    className="form-control wd-213 mt-1"
                    placeholder="Confirm new password"
                    value={userNewData.confirmPassword}
                    onChange={handleInputChange}
                    autoComplete="new-password"
                  />
                  {errors.confirmPassword && (
                    <div className="text-danger mt-1">
                      {errors.confirmPassword}
                    </div>
                  )}
                </div>
              </>
            )}

            <div className="d-flex mt-4">
              <button
                type="button"
                className="btn btn-secondary me-5"
                onClick={handleCancelClick}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={isUpdatingData}
              >
                {isUpdatingData ? "Updating...." : "Update"}
              </button>
            </div>
          </form>
        </section>
      </div>
    </div>
  );
}

export default Profile;
